import { MiProfilePicture } from "@miplatform/components";
import { useTheme } from "@mui/material";
import { ConfigCard, IConfigCardProps } from "../ConfigCard/ConfigCard";

export function ConfigProfileCard(props: Readonly<IConfigProfileCardProps>) {
  const { name, profilePhotoSrc, isActive, title, createdOn, onClick } = props;

  const theme = useTheme();

  return (
    <ConfigCard
      {...props}
      title={title ?? name}
      createdOn={createdOn}
      onClick={onClick}
      LeftComponent={
        <MiProfilePicture
          src={profilePhotoSrc}
          name={name}
          size={20}
          fontSize={12}
          sx={{
            borderRadius: "4px",
            backgroundColor: isActive
              ? theme.palette.primary.main
              : theme.palette.grey.darkAccent,
          }}
        />
      }
    />
  );
}

interface IConfigProfileCardProps extends IConfigCardProps {
  name: string;
  profilePhotoSrc?: string;
  isActive?: boolean;
}
